module.exports = __webpack_public_path__ + "img/crm2_1.c355df82.png";